import { render, staticRenderFns } from "./flow_sort.vue?vue&type=template&id=9d5474e6&"
import script from "./flow_sort.vue?vue&type=script&lang=js&"
export * from "./flow_sort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports